import { defineStore } from 'pinia';
import { useEventBus } from './eventBus';

export const alertsStore = defineStore('alerts', {
	state: () => ({
		_BACKEND_BITRIX_CONTROLLER_NAME: 'o2k:sitecore.api.Basket',
		
		/**
		 * Загружен ли блок на текущий момент 
		 * (не выполняются ли запросы на бэкенд или другие действия, его изменяющие)
		 * @type boolean
 		 */
		isLoaded: false,

		outOfStock: [],
		priceHasChanged: [],
		quantityHasChanged: [],
		errors: [],
		
		eventBus: useEventBus(),
	}),
	getters: {
		hasAlerts() {
			return this.outOfStock.length > 0 || this.priceHasChanged.length > 0 || this.quantityHasChanged.length > 0 || this.errors.length > 0;
		},
		hasErrors() {
			return this.errors.length > 0;
		}
	},
	actions: {
		init() {
			this.eventBus.subscribe('o2k:basketStore:afterDataUpdate', this.handleBasketStorageUpdate.bind(this));
		},

		handleBasketStorageUpdate(event) {
			if (this._isDebugEnabled)
				console.log('handleBasketStorageUpdate initiator:' + event.data.initiator);

			if (event.data.source?.alerts)
				this.setAlerts(event.data.source.alerts);
		},

		_errorNotify(message, errorData = null, error = null) {
			this.eventBus.emit(
				'o2k:order:error', 
				{
					message: message, 
					errorObject: error, 
					errorData: errorData
				}
			);
		},

		setAlerts(alerts) {
			this.outOfStock.splice(0);
			this.priceHasChanged.splice(0);
			this.quantityHasChanged.splice(0);
			this.errors.splice(0);
			
			alerts.outOfStock.forEach((item) => {
				this.outOfStock.push(item);
			});
			alerts.priceHasChanged.forEach((item) => {
				this.priceHasChanged.push(item);
			});
			alerts.quantityHasChanged.forEach((item) => {
				this.quantityHasChanged.push(item);
			});
			alerts.errors.forEach((item) => {
				this.errors.push(item);
			});
		},

		reloadAlerts() {
			this.isLoaded = false;
			window.BX.ajax.runAction(
				`${this._BACKEND_BITRIX_CONTROLLER_NAME}.getAlerts`,
				{
					data: {}
				}
			)
				.then((response) => {
					const responseData = response.data;
					if (responseData.alerts) {
						this.setAlerts(responseData.alerts);
					}
					this.isLoaded = true;
				})
				.catch((error) => {
					if (error.errors)
						error = error.errors.slice(-1)[0];
					this._errorNotify(error.message, null, error);
					this.isLoaded = true;
				});
		},

		resetPriceAlerts() {
			window.BX.ajax.runAction(
				`${this._BACKEND_BITRIX_CONTROLLER_NAME}.resetPriceAlerts`,
				{
					data: {}
				}
			);
		},

		resetQuantityAlerts() {
			window.BX.ajax.runAction(
				`${this._BACKEND_BITRIX_CONTROLLER_NAME}.resetQuantityAlerts`,
				{
					data: {}
				}
			);
		},

		resetOutOfStockAlerts() {
			window.BX.ajax.runAction(
				`${this._BACKEND_BITRIX_CONTROLLER_NAME}.resetOutOfStockAlerts`,
				{
					data: {}
				}
			);
		},
	},
});
